package com.appsyde.shared.modules.account.domain.model

data class MeUser(
    val id: String,
    val email: String,
    val name: String?
)

data class MeAccount(val id: String, val primaryEmail: String)

data class Me(
    val user: MeUser,
    val account: MeAccount,
    val role: String,
    val onboardingStatus: String? = null,
    val mustSubscribe: Boolean = false,
    val gmailConnectionStatus: String = "",
    val isOwner: Boolean = false,
    val workspaceDisplayName: String = "",
    val membersCount: Int = 0
)
